// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import React from 'react'
import { Step11FuneralWishes } from './Step11FuneralWishes'
import type { SaveStatus } from '@/hooks/useAutosave'

// Re-export with new name for wizard ordering clarity
// V41: saveRef doorgestuurd zodat GuidedWizardPage saveNow kan aanroepen
export function NewStep11FuneralWishes(props: {
  onSaveStatus: (s: SaveStatus) => void
  saveRef?: React.MutableRefObject<(() => Promise<void>) | null>
}) {
  return <Step11FuneralWishes {...props} />
}
